import type { RequestStatus, GenericError } from '@skynet/data-ws-core';
import type { TaskActions, TaskRandomizeValues, TaskTypes } from 'src/store/trading/apiKeys/types';

export enum TradingAddTaskCommands {
  Token = 'Token',
  AddTask = 'AddTask',
  Instruments = 'Instruments',
}

export interface TradingAddTaskState {
  error: null | GenericError;
  tokens: TradingApiKeysToken[] | null;
  filteredTokens: TradingApiKeysToken[];
  selectedToken: TradingApiKeysToken | null;
  instruments: TradingApiKeysInstruments[] | null;
  activeListenSection: string | null;
  isLoadingTickers: boolean;
  resAddTaskStatus: RequestStatus;
  searchValue: string;
  requestId: string;
}

export interface TokenValue {
  label: string;
  value: string;
  token: TradingApiKeysToken;
}

export interface TradingApiKeysToken {
  amount: number;
  ask: number;
  bid: number;
  depthMinus: number;
  depthPlus: number;
  exchangeID: number;
  marketVolume24: number;
  price: number;
  priceUpdateTime: string;
  quotes: string[];
  spread: number;
  ticker: string;
  volume: number;
  requestId: string;
}
export interface TradingApiKeysInstruments {
  amount: number;
  ask: number;
  bid: number;
  depthMinus: number;
  depthPlus: number;
  marketVolume24: number;
  price: number;
  quotePrice: number;
  priceUpdateTime: string;
  quotes: string[];
  spread: number;
  ticker: string;
}

export interface AddTaskPayload {
  type: TaskTypes;
  action: TaskActions;
  priceLimit: number;
  volume: number;
  // volumeSlider: number;
  // volumeInput: number;
  orderSize?: number;
  orderPeriod?: number;
  aggression?: number;
  liquidity?: number;
  randomize: TaskRandomizeValues;
}

export interface AddTaskFormPayload {
  ticker?: TradingApiKeysToken['ticker'];
  type: TaskTypes;
  action: TaskActions;
  priceLimit: number;
  volume: number;
  volumeSlider?: number;
  volumeInput?: number;
  orderSize?: number;
  orderSizeSlider?: number;
  liquidity?: number;
  liquiditySlider?: number;
  orderPeriod?: number;
  aggression?: number;
  aggressionSlider?: number;
  randomize: TaskRandomizeValues;
}
